var Reveals = {

	trigger_bottom: 1,
	trigger_low: 0.9,
	trigger_high:0.7,

	speed: 0.6,
	decal:40,

	init:function(){
		
		
		$('[gsap-reveal-successif]').each(function(i, parent){

			$(this).find("[gsap-reveal-successif-child]").each(function(j, elt){


				gsap.to(elt, { scrollTrigger:{
					trigger:parent,
					toggleActions:"restart none none reverse",
					start :"top 80%",
					markers:true,
				}, opacity:1,  duration:1, delay:j });


			})
		});

		$('[gsap-reveal-bottom]').each(function (i, elt) {
			gsap.to(elt, { scrollTrigger:{
				trigger:elt,
				toggleActions:"restart none none reverse",
				start :"top 80%",
				/*markers:true,*/
			}, opacity:1, y:0, duration:1 });
		});
		
		$('[gsap-reveal-target]').each(function (i, elt) {
			
			var _trigger = $(this).attr("data-target");
			
			
			gsap.to(elt, { scrollTrigger:{
				trigger:$("." + _trigger),
				toggleActions:"restart none none reverse",
				start :"top 80%",
				/*markers:true,*/
			}, opacity:1, y:0, duration:1 });
		});

		/*
		$('[gsap-reveal]').each(function (i, elt) {			
			tween = TweenLite.fromTo(elt, Reveals.speed, {autoAlpha:0}, {autoAlpha:1, ease:Quad.easeOut});
			scene = new ScrollMagic.Scene({triggerElement: elt, triggerHook: Reveals.trigger_low})
				.setTween(tween)
				.addTo(App.controller)
		});
		$('[gsap-reveal-scale]').each(function (i, elt) {
			tween = TweenLite.fromTo(elt, Reveals.speed, {scale:0.9}, {scale:1, ease:Quad.easeOut});
			scene = new ScrollMagic.Scene({triggerElement: elt, triggerHook: Reveals.trigger_bottom})
				.setTween(tween)
				.addTo(App.controller)
		});
		$('[gsap-reveal-top]').each(function (i, elt) {
			tween = TweenLite.fromTo(elt, Reveals.speed, {y:-1 * Reveals.decal, autoAlpha:0}, {y:0, autoAlpha:1, ease:Quad.easeOut});
			scene = new ScrollMagic.Scene({triggerElement: elt, triggerHook: Reveals.trigger_low})
				.setTween(tween)
				.addTo(App.controller)
		});
		$('[gsap-reveal-bottom]').each(function (i, elt) {
			tween = TweenLite.fromTo(elt, Reveals.speed, {y:Reveals.decal, autoAlpha:0}, {y:0, autoAlpha:1, ease:Quad.easeOut});
			scene = new ScrollMagic.Scene({triggerElement: elt, triggerHook: Reveals.trigger_low})
				.setTween(tween)
				.addTo(App.controller)
		});
		$('[gsap-reveal-left]').each(function (i, elt) {
			tween = TweenLite.fromTo(elt, Reveals.speed, {x:-1 * Reveals.decal, autoAlpha:0}, {x:0, autoAlpha:1, ease:Quad.easeOut});
			scene = new ScrollMagic.Scene({triggerElement: elt, triggerHook: Reveals.trigger_high})
				.setTween(tween)
				.addTo(App.controller)
		});
		$('[gsap-reveal-right]').each(function (i, elt) {
			tween = TweenLite.fromTo(elt, Reveals.speed, {x:Reveals.decal, autoAlpha:0}, {x:0, autoAlpha:1, ease:Quad.easeOut});
			scene = new ScrollMagic.Scene({triggerElement: elt, triggerHook: Reveals.trigger_high})
				.setTween(tween)
				.addTo(App.controller)
		});
		$('[gsap-reveal-split]').each(function (i, elt) {
			splittext = new SplitText(elt, {type:"words"});
			timeline = new TimelineMax();
			timeline.staggerFrom(splittext.words, Reveals.speed, {y:10, autoAlpha:0}, 0.03);
			scene = new ScrollMagic.Scene({triggerElement: elt, triggerHook: Reveals.trigger_low})
				.setTween(timeline)
				.addTo(App.controller)
		});
		*/
	}
}

$(document).ready(function() {
	gsap.registerPlugin(ScrollTrigger);
	Reveals.init();
});